import {HttpClient} from "@angular/common/http";
import {inject, Service} from "@angular/core";
import type {IJsonObject} from "dcerialize";
import {Deserialize} from "dcerialize";
import type {Observable} from "rxjs";
import {map} from "rxjs";
import type {IPaginated, IPaginationQuery} from "../../models/IPaginated";
import {Timeline} from "../../models/Timeline/Timeline";
import type {TimelineEvent} from "../../models/Timeline/TimelineEvent";
import {BaseApi} from "./base-api";

@Service()
export class TimelineApi extends BaseApi {
  private readonly http = inject(HttpClient);

  public constructor() {
    super("timeline");
  }

  public getTimeline(paginationQuery?: IPaginationQuery): Observable<IPaginated<TimelineEvent>> {
    const params = this.httpParamsFromPaginationQuery({
      sortBy: {
        field: "point-in-time",
        direction: "ascending",
      },
      ...(paginationQuery ?? {}),
    });
    return this.http.get<IJsonObject>(this.getEndpointUrl(), params ? {params} : undefined)
      // eslint-disable-next-line new-cap
      .pipe(map(json => Deserialize(json, () => Timeline)));
  }
}
